<template>
  <div>
    <Modal
            class-name="lc-law-exam-invoke"
      v-model="show"
      :closable="true"
      width="560px"
      :mask-closable="false"
      @close="close"
    >
      <div slot="close">
        <i class="one one-close" @click="close"/>
      </div>
      <div class="content">
        <span class="title">发起体检</span>
        <div class="content-inner">
          <div class="content-inner-left">
            <span class="success">
              <i class="el-icon-circle-check check" />
              您已成功创建法治体检问卷调查链接
            </span>
            <div class="action">
              <div class="link text-overflow">
                {{ url }}
              </div>
              <i-button
                ref="copyBtn"
                class="copy-btn"
                @click="copy()"
              >
                复制链接
              </i-button>
            </div>
            <div class="bottom">
              <span>1.复制链接</span>
              <span>2.通过QQ、微信、微博、短信等分享给企业</span>
            </div>
          </div>
          <div class="line" />
          <div class="content-inner-right">
            <img
              id="qrcode"
              class="qrcode"
            >
            <i-button
              class="download"
              @click="downloadQrcode"
            >
              下载二维码
            </i-button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import QRCode from 'qr-code-with-logo'
export default {
  name: 'LawExamInvoke',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data:function(){
    return {
      show:false
    }
  },
  mounted () {
    this.generateQrcode()
    this.show=true
  },
  methods: {
    copy () {
      this.$copyText(this.url).then(e => {
        this.$Message.success('复制链接成功')
        this.$emit('close')
      })
    },
    close () {
      this.$emit('close')
    },
    downloadQrcode () {
      let a = document.createElement('a')
      a.href = document.getElementById('qrcode').src
      a.download = '法治体检二维码'
      a.click()
      this.$Message.success('二维码下载成功')
    },
    generateQrcode () {
      this.$nextTick(_ => {
        QRCode.toImage({
          image: document.getElementById('qrcode'),
          content: this.url,
          width: 200,
          download: (callback) => {
            this.downloadHandler = callback
          },
          nodeQrCodeOptions: {
            margin: 1
          }
        })
      })
    }
  }
}
</script>

<style lang="stylus">
.lc-law-exam-invoke
  .one-close{
    font-size 20px;
    color #666666;
    margin-right 10px
  }
  .el-dialog__header
    margin-bottom 0px
    padding-top 10px
  .el-dialog__body
    padding-top 0px
    padding-bottom 0px
  .ivu-modal-footer{
    display none
  }
  .content
    display flex
    flex-direction column
    .title
      font-size 18px
      font-weight 500
    &-inner
      display flex
      padding 10px 0 30px
      &-left
        flex 1
        min-width 0
        .success
          margin-bottom 10px
          display flex
          align-items center
          .check
            display flex
            font-size 14px
            margin-right 4px
            color #9ad855
        .bottom
          display flex
          margin 10px 0 16px
          flex-direction column
          font-size 12px
          color #a7a7a7
        .action
          display flex
          height 32px
          justify-content space-between
          min-width 0
          .link
            border 1px solid #dcdfe6
            line-height 32px
            font-size 13px
            border-radius 2px
            padding 0 10px
            flex 1
          .copy-btn
            margin-left 10px
            line-height 30px
            padding 0 16px
            border-radius 2px
            background-color  #f7f7f7
      .line
        height 140px
        width 1px
        background-color #eeeeee
        margin 0 30px
      &-right
        display flex
        flex-direction column
        align-items center
        .qrcode
          width 104px
          height 104px
        .download
          margin-top 10px
          line-height 30px
          padding 0 16px
          background-color #666666
          color  #fff
</style>
